import { render } from "./TableView.vue?vue&type=template&id=0ba6c3c2&scoped=true"
import script from "./TableView.vue?vue&type=script&lang=js"
export * from "./TableView.vue?vue&type=script&lang=js"

import "./TableView.vue?vue&type=style&index=0&id=0ba6c3c2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ba6c3c2"]])

export default __exports__